import { createSlice } from "@reduxjs/toolkit";

export const theSlice = createSlice({
  name: 'rush-surcharge-settings',
  initialState: {
    data: { thresholdDays: 0, amount: 0 },
    loaded: false,
  },
  reducers: {
    loadRushSurchargeSettings: (state, action) => {
      const data = action.payload;
      state.data = data;
      state.loaded = true;
    },
    updateRushSurchargeSetting: (state, action) => {
      const data = action.payload
      Object.assign(state.data, data);
    }
  }
});

export const {
  loadRushSurchargeSettings,
  updateRushSurchargeSetting,
} = theSlice.actions;
export default theSlice.reducer;
